// ezyaa-patch:BEGIN ki-assist
// Warum: Menue und Funken-Knopf muessen wissen, ob der KI-Assistent aus dem
//        ezyaa-Backend fuer dieses Konto eingeschaltet ist. Den Zustand legt
//        app/views/layouts/_ezyaa_assist.html.erb einmal pro Konto unter
//        window.ezyaaAssist ab und feuert 'ezyaa-assist-ready'.
// Umkehren: Datei loeschen; die beiden Importe in ReplyTopPanel.vue und
//           CopilotMenuBar.vue entfernen.
//
// Additiv: eigene Datei, kein Eingriff in useCaptain. Ohne das Teilstueck im
// Layout (Produktion ohne ONBOARDING_BAR_API_URL) bleibt `enabled` schlicht
// false und alles verhaelt sich wie Chatwoots Original.
import { onBeforeUnmount, onMounted, ref } from 'vue';

const enabled = ref(!!(window.ezyaaAssist && window.ezyaaAssist.enabled));
// Name der Konto-KI (Prompt-Variable BOT_NAME), damit die Oberflaeche
// "Ela schreibt" sagt statt Chatwoots "Copilot denkt".
const name = ref((window.ezyaaAssist && window.ezyaaAssist.name) || 'KI');
let zuhoerer = 0;

function uebernehmen(e) {
  const detail = (e && e.detail) || window.ezyaaAssist || {};
  enabled.value = !!detail.enabled;
  name.value = detail.name || 'KI';
}

export function useEzyaaAssist() {
  onMounted(() => {
    // Falls das Teilstueck schon vor dieser Komponente fertig war.
    uebernehmen();
    if (zuhoerer === 0)
      window.addEventListener('ezyaa-assist-ready', uebernehmen);
    zuhoerer += 1;
  });
  onBeforeUnmount(() => {
    zuhoerer -= 1;
    if (zuhoerer === 0)
      window.removeEventListener('ezyaa-assist-ready', uebernehmen);
  });
  return { enabled, name };
}
// ezyaa-patch:END ki-assist
